// extracted by mini-css-extract-plugin
module.exports = {"title":"_1CnQOckbe7cImI_33NOZMz","monthName":"_1S4fm4ZLR3vUZ-FrB_ltKQ","leftArrow":"_2yRCQhJM0SIki2CXF0gLO6","rightArrow":"_2WdCBKtaBh1aZ_nGlPSPHs"};